import { Skeleton } from '@mui/material';
import React from 'react';

interface LoadingRowsComponentProps {
  rows?: number;
}
export const LoadingRowsComponent = ({ rows }: LoadingRowsComponentProps) => {
  return (
    <>
      {Array.from({ length: rows ?? 5 }).map((_, index) => (
        <Skeleton key={index} data-testid="Loading" />
      ))}
    </>
  );
};

LoadingRowsComponent.defaultProps = {
  rows: 5
};
